import { Component, Input, OnDestroy, OnInit } from '@angular/core';

import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as StrategyActions from '../../strategy.actions';
import * as fromStrategy from '../../reducers';

@Component({
  selector: 'app-strategy-3a',
  templateUrl: './strategy-3a.component.html',
  styleUrls: ['./strategy-3a.component.scss'],
  standalone: false
})
export class Strategy3AComponent implements OnDestroy, OnInit {
  @Input() step: number;
  @Input() tabSelected: number;
  @Input() qlOnboardingStep: number;
  isStrategyInitialised: boolean;

  protected readonly onDestroy$ = new Subject<void>();

  constructor(private store: Store) {
    this.store
      .select(fromStrategy.selectIsStrategyInitialised)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((value) => {
        this.isStrategyInitialised = value;
      });
  }

  ngOnInit(): void {
    if (!this.isStrategyInitialised) {
      this.store.dispatch(StrategyActions.getLatestStrategyData({ fetchAll: this.step >= 2 || this.qlOnboardingStep >= 4 }));
    }
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
}
